import { Stack } from '@mui/material';
import { ReactNode } from 'react';

const Layout = ({ children }: { children: ReactNode }) => (
  <Stack height='100vh' sx={{ height: 'calc(var(--vh, 1vh) * 100)' }} className='App'>
    {children}
  </Stack>
);
export default Layout;
